export const BASE_TITLE = 'Supreme Motors Panel';

export enum USER_TYPES {
    SUPER_ADMIN = 10,
    CLIENT = 20,
    ADMIN = 30
}